<template>
  <div :style="mainContentViewHeight" class="main_center">
    <div class="content">
      <searchBox
              :dialogVisible.sync="moreSearchItem"
              @dialogCancle="dialogCancle"
              title="更多筛选">
        <div class="search-drawer">
          <el-form :model="dataForm" label-position="top" ref="form">
              <el-form-item label="姓名：" props="personName">
                <el-input clearable placeholder="请输入内容搜索" v-model="dataForm.personName"></el-input>
              </el-form-item>
              <el-form-item label="身份证号：" props="personCode">
                <el-input clearable placeholder="请输入内容搜索" v-model="dataForm.personCode"></el-input>
              </el-form-item>
              <el-form-item label="角色：" props="roleType">
                <el-select clearable style="width:100%;" v-model="dataForm.roleCode"  value-key="value">
                  <el-option label="全部" value="99"></el-option>
                  <el-option v-for="(item,index) in  rolesList"
                             :key="index"
                             :label="item.name"
                             :value="item.value"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="胸牌ID：" props="cardId">
                <el-input clearable placeholder="请输入内容搜索" v-model="dataForm.cardId"></el-input>
              </el-form-item>
              <el-form-item label="状态：" >
                <el-select v-model="dataForm.state" style="width:100%;">
                  <el-option label="全部" value="99"></el-option>
                  <el-option label="已绑定" :value="1"></el-option>
                  <el-option label="已解绑" :value="0"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="数据所属部门：">
                        <select-depart-tree 
                            ref="selectDepartTreeRef"
                            :type="'2'"
                            :modelValue.sync="dataForm.superviseDeptCodeList"  
                            :isMultiple="true" 
                            @handleDeptType="(val)=>changeDept(val,'5')" >
                            </select-depart-tree>
                    </el-form-item>
          </el-form>
          <div class="search-drawer__footer">
            <el-button @click="searchBtn" size="small" type="primary">查询</el-button>
            <el-button @click="refresh" plain size="small">重置</el-button>
          </div>
        </div>
      </searchBox>

      <div class="search-content">
        <div class="mainBtn">
          <el-button @click="addOrUpdateHandle('','edit')" size="small" type="primary" v-if="hasBtnPermission('btn_jz_idcard_bandings_opt')">新增绑定</el-button>
        </div>
        <div class="searchBtn">
          <span class="label-form">姓名：</span>
          <el-input @keyup.enter.native="searchBtn" clearable placeholder="请输入内容搜索" style="width: 200px" v-model="dataForm.personName"></el-input>
          <span class="label-form">身份证号：</span>
          <el-input @keyup.enter.native="searchBtn" clearable placeholder="请输入内容搜索" style="width: 200px" v-model="dataForm.personCode"></el-input>
          <el-button @click="searchBtn" size="small" style="margin-left: 12px" type="primary">搜索</el-button>
          <el-button @click="moreSearchItem = true" icon="el-icon-arrow-down" size="mini" type="text">更多搜索</el-button>
          <el-divider direction="vertical"></el-divider>
          <el-button @click="refresh" icon="el-icon-refresh" type="text"></el-button>
        </div>
      </div>
      <el-table
          class="table-content"
          :data="dataList"
          border
          stripe
          :header-cell-style="this.$globalGrayTableHeaderStyle"
          :height="tableMaxHeight"
          v-loading="dataListLoading"
          @selection-change="selectionChangeHandle">
        <el-table-column
                type="index"
                fixed="left"
                header-align="left"
                align="left"
                label="序号"
                width="50"
                :index="getRowsIndex">
        </el-table-column>
        <el-table-column
                fixed="right"
                v-if="hasBtnPermission('btn_jz_idcard_bandings_show') || hasBtnPermission('btn_jz_idcard_bandings_opt')"
                header-align="center"
                align="center"
                width="100"
                label="操作">
          <template slot-scope="scope">
            <el-button type="text" size="small" v-if="hasBtnPermission('btn_jz_idcard_bandings_show')" @click="addOrUpdateHandle(scope.row.id,'view')">查看</el-button>
            <el-button type="text" size="small" v-if="hasBtnPermission('btn_jz_idcard_bandings_opt')" @click="addOrUpdateHandle(scope.row.id,'edit')">{{scope.row.state == '1'?'解绑':'绑定'}}</el-button>
          </template>
        </el-table-column>

        <el-table-column
                prop="cardId"
                header-align="center"
                align="center"
                width="110"
                label="胸牌ID">
        </el-table-column>
        <el-table-column
            prop="personName"
            align="center"
            label="姓名">
        </el-table-column>
        <el-table-column
            prop="personCode"
            header-align="center"
            align="center"
            width="180"
            label="身份证号">
        </el-table-column>
        <el-table-column
            prop="linkphone"
            align="center"
            width="110"
            label="联系方式">
        </el-table-column>

        <el-table-column
            prop="roleName"
            header-align="center"
            align="center"
            label="角色">
        </el-table-column>
        <el-table-column
                prop="state"
                header-align="center"
                align="center"
                label="状态">
          <template slot-scope="scope">
            <span>
              <el-tag :type="scope.row.state=='1'?'success':'danger'" size="small" :hit="false" effect="plain">{{scope.row.state=='1'?"已绑定":"已解绑"}} </el-tag>
            </span>
          </template>
        </el-table-column>

        <el-table-column
            prop="bandTime"
            header-align="center"
            align="center"
            width="160"
            label="绑定时间">
        </el-table-column>
        <el-table-column
                prop="releaseTime"
                header-align="center"
                align="center"
                width="160"
                label="解绑时间">
        </el-table-column>

      </el-table>
      <el-pagination
          @size-change="sizeChangeHandle"
          @current-change="currentChangeHandle"
          :current-page="pageIndex"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          :total="totalPage"
          layout="total, sizes, prev, pager, next, jumper">
      </el-pagination>
    </div>
    <!-- 弹窗, 新增 / 修改 -->
    <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>

  </div>
</template>

<script>
    import AddOrUpdate from './breastpiece_bind_edit'
    import selectDepartTree from "@/views/modules/components/selectDepartTree"
    import { mapState } from "vuex";
    export default {
  props: ['mainContentViewHeight'],
  components: {
    AddOrUpdate,
    selectDepartTree
  },
  data() {
    return {
      dataForm: {
        personName:"",
        personCode:"",
        roleCode:"",
        uwbUuid:"",
        state:"",
        superviseDeptCodeList:[],// 数据所属部门
      },
      tableMaxHeight: document.documentElement.clientHeight - 227 ,
      moreSearchItem:false,
      rolesList:[],
      dataList: [],
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      dataListLoading: false,
      dataListSelections: [],
      addOrUpdateVisible: false
    };
  },
  created() {
    this.getDic('jz_dgwitness_person_role');
  },
  computed:{
		...mapState({
        isAdmin: state => {return state.user.userinfo.selectRoleCode == "ADMIN"}

    }),
	},
  activated() {
    this.getDataList();
  },
  watch:{
      uerdefultOptionCode:{
        handler (val,oldVal){
          if(val.length!==0){this.getDataList()}
        }
    }
    },
  computed: {
        ...mapState({
            uerdefultOptionCode: state => state.dataDictionary.uerdefultOptionCode,
        })

  },
  mounted() {
    const that = this;
    let resizeTag = true;
    window.onresize = () => {
      if(resizeTag) { //防抖动
        that.ifmove();
        resizeTag = false
        setTimeout(() => {
          resizeTag = true
        }, 1000)
      }
    }
    that.ifmove();
  },
  methods: {
    changeDept(val,str){//切换部门
            this.dataForm.superviseDeptCodeList=[]
            if(str==='5'){
                // 多选
                val.forEach((item,index)=>{
                    if( item.type!=="region"){
                    this.dataForm.superviseDeptCodeList.push(item.code)
                    }
                })
            }
        },
    ifmove() {
      // let hasBtnPermisson = this.hasBtnPermission("btn_jz_witness_record_delete");

      let tableMaxHeight = document.documentElement.clientHeight - 227;
      this.pageSize = parseInt((this.tableMaxHeight) / 50 ) || 1;
      this.$nextTick(() => {
        this.tableMaxHeight = tableMaxHeight
      })
      this.getDataList()

    },
    getDic(type) { // 获取字典

      this.$httpReq.get('/sys/dictData/getList?type=' + type).then(res => {
        if (res.data.code === '1') {
          switch (type) {
            case 'jz_dgwitness_person_role':this. rolesList = res.data.data;break;
          }
        }
      })
    },
    dialogCancle(){
      this.moreSearchItem = false
    },
    //搜索按钮
    searchBtn(){
      this.pageIndex=1;
      this.moreSearchItem = false
      this.getDataList()
    },
    refresh() {//刷新按钮
      this.pageIndex = 1;
      this.dataForm = {
        personName:"",
        personCode:"",
        roleCode:"",
        uwbUuid:"",
        state:"99",
       superviseDeptCodeList:this.uerdefultOptionCode
      }
        // 重置默认所属数据
       if( this.$refs.selectDepartTreeRef){
        this.$refs.selectDepartTreeRef.getUserTreeOption()
    }
      this.moreSearchItem = false
      this.getDataList()

    },

    getRowsIndex(index) {
      return (this.pageIndex - 1) * this.pageSize + index + 1
    },
    // 每页数
    sizeChangeHandle (val) {
      this.pageSize = val
      this.pageIndex = 1
      this.getDataList()
    },
    // 当前页
    currentChangeHandle (val) {
      this.pageIndex = val
      this.getDataList()
    },
    // 多选
    selectionChangeHandle (val) {
      this.dataListSelections = val
    },
    // 获取数据列表
    getDataList() {

      this.dataListLoading = true;

      this.dataForm.superviseDeptCodeList= this.dataForm.superviseDeptCodeList.length==0?this.uerdefultOptionCode:this.dataForm.superviseDeptCodeList
      var filter = JSON.parse(JSON.stringify(this.dataForm))
      filter.roleCode = (filter.roleCode=="99" || filter.roleCode==="")?null:this.dataForm.roleCode;
      filter.state = (filter.state=="99" || filter.state==="")?null:this.dataForm.state;

      this.$httpReq({
        url: '/evalCardBrands/sysEvalCardBrands/list',
        method: 'post',
        data: {
          page: this.pageIndex,
          rows: this.pageSize,
          filter: filter
        }
      }).then(({data}) => {
        if (data) {
          this.dataList = data.rows
          this.totalCount = data.total
          this.pageIndex = data.pageIndex
        } else {
          this.dataList = []
          this.totalCount = 0
          this.pageIndex = 1
        }
        this.dataListLoading = false
      })
    },
    // 新增 / 修改
    addOrUpdateHandle (id,type) {
      this.addOrUpdateVisible = true
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init(id,type)
      })
    },

  },
};
</script>
